import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p399914144873160704',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
